import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/node_modules/next/dist/client/link.js");
